import React, { useState, useEffect } from 'react';
import { 
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import VClientContainer from './client/VClientContainer';
import VBienContainer from './bien/VBienContainer';
import VEncaissementContainer from './encaissement/VEncaissementContainer';
import { constants } from '../../types/constants';
import ConfirmVente from './ConfirmVente';
import { connect } from 'react-redux';
import { clearTableClients } from '../../flux/actions/clientActions';
import { getUsers } from '../../flux/actions/userActions';
import { clearEncaissementLines } from '../../flux/actions/encaissementlineActions';
import { getRemainingEncaissements } from '../../flux/actions/encaissementActions';
import { VenteContainer, IVenteReduxProps, ITableClientLine, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faSearch, faSearchPlus, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'

import ReactTooltip from 'react-tooltip';
import { useAlert } from "react-alert";
import DatePicker from "reactstrap-date-picker";
import { getLastNumDossier } from '../../flux/actions/venteActions';

const VenteContainerComponent = ({ 
  isAssociation,
  encaissementline,
  clearEncaissementLines,
  clearTableClients,
  getUsers,
  user,
  getRemainingEncaissements,
  bien,
  auth
 }: VenteContainer) => {
  const alert = useAlert();
  const { loading: loadingB } = bien;
  const { users, loading: loadingU } = user;
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const [userValue, setUserValue] = useState<any>('');
  const [dossierValue, setDossierValue] = useState('');
  const [dateValue, setDateValue] = useState(new Date().toISOString());
  const [observationValue, setObservationValue] = useState('');
  const [remiseValue, setRemiseValue] = useState(0);
  const [remiseTotalValue, setRemiseTotalValue] = useState(true);
  const [prixAafficherValue, setPrixAafficherValue] = useState(0);
  const [prixAafficherTotalValue, setPrixAafficherTotalValue] = useState(false);
  const { encaissementlines } = encaissementline;
  const [selectedBien, setSelectedBien] = useState<any>(null);
  const [association, setAssociation] = useState(undefined);
  // const [clientTableLines, setClientTableLines] = useState<ITableClientLine[]>([]);
  // const TAB_CLIENT = "TAB_CLIENT", TAB_BIEN = "TAB_BIEN", TAB_ENCAISSEMENT = "TAB_ENCAISSEMENT";
  const [activeTab, setActiveTab] = useState(constants.TAB_BIEN);
  const selectSocieteOptions = auth?.user?.societes?.sort((a, b) => (!a.LIBELE && !b.LIBELE) ? 0 : !a.LIBELE ? -1 : !b.LIBELE ? 1 : a.LIBELE.localeCompare(b.LIBELE)).map(e => ({value: e, label: e.LIBELE})) || [];
  const [societeValue, setSocieteValue] = useState<any>('');
  // const [associationValue, setAssociationValue] = useState(false);
  const [disableAssociation, setDisableAssociation] = useState(false);
  const [initializeModal, setInitializeModal] = useState(false);
  const [lastUsedDossierLoading, setLastUsedDossierLoading] = useState(false);
  const [lastUsedDossierNumber, setLastUsedDossierNumber] = useState('');
  
  const handleToggleInitialize = () => setInitializeModal(!initializeModal);

  const clearAll = () => {
    setSelectedBien(null);
    // setClientTableLines([]);
    clearTableClients();
    clearEncaissementLines();
    setUserValue('');
    setDossierValue('');
    setDateValue(new Date().toISOString());
    setObservationValue('');
    getRemainingEncaissements();
  }

  const initializeHandle = () => {
    setInitializeModal(false);
    clearAll();
  }

  // const changeAssociationHandle = (e) => {
  //   setSelectedBien(null);
  //   setAssociationValue(e.target.checked);
  //   setDisableAssociation(true);
  //   setTimeout(() => setDisableAssociation(false), 1000);
  // };

  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  }

  const commercialMyself = () => {
    if(auth?.user?.id)
      setUserValue(users.find(e => e.id === auth.user.id))
  }

  const dossierChangeHandler = (e: ITarget) => setDossierValue(e.target.value);
  const dateChangeHandler = (e, t) => setDateValue(e);
  const observationChangeHandler = (e: ITarget) => setObservationValue(e.target.value);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  useEffect(() => {
    getRemainingEncaissements();
  }, [getRemainingEncaissements]);

  useEffect(() => {
    setSelectedBien(null);
    setDossierValue('');
    setLastUsedDossierNumber('');
  }, [societeValue]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLastUsedDossierNumber('');
    if(selectedBien?.TYPE && !selectedBien.TYPE.includes("APP") && !selectedBien.TYPE.includes("MAG"))
      setDossierValue(selectedBien.N)
    else
      setDossierValue('')
  }, [selectedBien]);

  // useEffect(() => {
  //   if(auth?.user?.societes?.length)
  //     for(let e of auth.user.societes)
  //       if(e.id == auth.user.last_societe){
  //         setSocieteValue(e);
  //         break
  //       }
  // }, [auth?.user?.societes]);

  // useEffect(() => {
  //   if(auth?.user?.id !== undefined && userValue === '')
  //     setUserValue(userOptions.find(e => e.value.id === auth.user.id)?.value || '')
  // }, [auth?.user?.id, users]);

  useEffect(() => () => {
    clearEncaissementLines();
  }, []);

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  const lastNumDossier = async () => {
    if(selectedBien && societeValue){
      if(selectedBien.TYPE && (selectedBien.TYPE.includes("APP") || selectedBien.TYPE.includes("MAG"))){
        setLastUsedDossierLoading(true);
        const res = await getLastNumDossier(societeValue.id, selectedBien.TYPE.includes("APP") ? constants.APPARTEMENT : selectedBien.TYPE.includes("MAG") ? constants.MAGASIN : constants.LOT);
        setLastUsedDossierLoading(false);
        if(res){
          let numDossier = res.NUM_DOSS;
          alert.info("Dernier numéro de dossier utilisé: " + numDossier);
          setLastUsedDossierNumber(numDossier);
          if(!isNaN(numDossier) && Number(numDossier)){
            numDossier = Number(numDossier) + 1;
            setDossierValue(numDossier);
          }
        }
        else
          alert.error("Une erreur s'est produite - 354");
      }
    }
    else {
      alert.error("Veuillez choisir un bien");
    }
  }

  return false ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
           {/* style={{marginBottom: "20px"}}> */}
          <Col sm="12" md="6"><h2 className="title">{isAssociation ? "Vente association" : "Nouvelle vente"}</h2></Col>
          {/* <Col sm="12" md="2" className="societesSwitch">
            <CustomInput type="switch" id="assiociation" name="associationSwitch" label={<div>Association&nbsp;{disableAssociation && <FontAwesomeIcon icon={faSpinner} className={"spinner"} />}</div>} checked={associationValue} onChange={changeAssociationHandle} disabled={disableAssociation} />
          </Col> */}
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="societe">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
              <Select
                id="societe"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Chercher par nom...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                options={selectSocieteOptions}
                isDisabled={loadingB}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col>
        </Row>
      </Container>
      <Container className="venteInputsContainer">
        <Row>
          <Col xs="12" sm="6" md="2">
            <FormGroup style={{position: "relative"}}>
              <Label for="dossier">Dossier N°&nbsp;</Label>
              <span className="labelFloatingSpan"><FontAwesomeIcon icon={lastUsedDossierLoading ? faSpinner : faSearch} className={lastUsedDossierLoading ? "spinner" : ""} data-tip data-for="numdossiertooltip" onClick={lastNumDossier} /></span>
              <ReactTooltip effect="solid" id="numdossiertooltip" type={"dark"}>
                Générer automatiquement le numéro de dossier
              </ReactTooltip>
              <Input id="dossier" placeholder="N° du dossier..." disabled={selectedBien?.TYPE && !selectedBien.TYPE.includes("APP") && !selectedBien.TYPE.includes("MAG")} value={dossierValue} onChange={dossierChangeHandler} />
              {lastUsedDossierNumber !== '' ? <div className="bottomFloatingInputText">Dernier numéro utilisé: <b>{lastUsedDossierNumber}</b></div> : null}
            </FormGroup>
          </Col>
          <Col xs="12" sm="6" md="3">
            <FormGroup>
              <Label>Date de vente</Label>
              <DatePicker id="daDatepicker"
                value={dateValue}
                dateFormat={constants.DP_DATE_FORMAT}
                dayLabels={constants.DP_DAYS}
                monthLabels={constants.DP_MONTHS}
                weekStartsOn={constants.DP_WEEK_START}
                disabled
                onChange={(v,f) => dateChangeHandler(v, f)} />
            </FormGroup>
          </Col>
          <Col xs="12" sm="6" md="3">
            <FormGroup>
              <Label for="user" style={{display: "flex", justifyContent: "space-between"}}>Commercial{!!(!userValue || userValue?.id !== auth?.user?.id) && <div style={{cursor: "pointer", textDecoration: "underline", paddingLeft: "3px"}} onClick={commercialMyself}>Moi-même</div>}</Label>
              <Select
                name="user"
                className="reactselect"
                classNamePrefix="react-select"
                value={userValue ? {label: userValue["username"], value: userValue} : null}
                onChange={handleUserChange}
                placeholder={'Chercher par nom...'}
                isClearable={true}
                isLoading={loadingU}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='name'
                // valueKey='countryCode'
                options={userOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
            </FormGroup>
          </Col>
          <Col xs="12" sm="6" md="4">
            <FormGroup>
              <Label for="observation">Observation</Label>
              <Input id="observation" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} />
            </FormGroup>
          </Col>
        </Row>
      </Container>
      <Container className="venteContainer">
        <Row className="justify-content-end">
          <span className="initializeBtn" style={{color: "tomato"}} title="Vider tous les champs dans tous les onglets" onClick={() => setInitializeModal(true)}><FontAwesomeIcon icon={faTrash} style={{fontSize: "small"}} />&nbsp;Réinitialiser la vente</span>
        </Row>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === constants.TAB_BIEN ? "active" : ""}
              onClick={() => { toggle(constants.TAB_BIEN); }} >
              Bien
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === constants.TAB_CLIENT ? "active" : ""}
              onClick={() => { toggle(constants.TAB_CLIENT); }} >
              Clients
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === constants.TAB_ENCAISSEMENT ? "active" : ""}
              onClick={() => { toggle(constants.TAB_ENCAISSEMENT); }} >
              Encaissements
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={constants.TAB_BIEN}>
            <VBienContainer project={societeValue} isAssociation={isAssociation} selectedBien={selectedBien} setSelectedBien={setSelectedBien} association={association} setAssociation={setAssociation} remiseValue={remiseValue} setRemiseValue={setRemiseValue} remiseTotalValue={remiseTotalValue} setRemiseTotalValue={setRemiseTotalValue} prixAafficherValue={prixAafficherValue} setPrixAafficherValue={setPrixAafficherValue} prixAafficherTotalValue={prixAafficherTotalValue} setPrixAafficherTotalValue={setPrixAafficherTotalValue} />
          </TabPane>
          <TabPane tabId={constants.TAB_CLIENT}>
            <VClientContainer /*tableLines={clientTableLines} setTableLines={setClientTableLines}*/ userValue={userValue} projet={societeValue} />
          </TabPane>
          <TabPane tabId={constants.TAB_ENCAISSEMENT}>
            <VEncaissementContainer project={societeValue} /*clients={clientTableLines}*/ bien={selectedBien} encaissementlines={encaissementlines} switchToBien={() => (setActiveTab(constants.TAB_BIEN), window.scrollTo(0, 0))} remiseValue={remiseValue} remiseTotalValue={remiseTotalValue} prixAafficherValue={prixAafficherValue} prixAafficherTotalValue={prixAafficherTotalValue} />
          </TabPane>
        </TabContent>
      </Container>
      <ConfirmVente /*clients={clientTableLines}*/ bien={selectedBien} encaissements={encaissementlines} isAssociation={isAssociation} association={association} setActiveTab={setActiveTab} switchToBien={() => (setActiveTab(constants.TAB_BIEN), window.scrollTo(0, 0))} clearAll={clearAll} selectedProjet={societeValue} numDossier={dossierValue} dateVente={dateValue} observation={observationValue} userValue={userValue} remiseValue={remiseValue} remiseTotalValue={remiseTotalValue} prixAafficherValue={prixAafficherValue} prixAafficherTotalValue={prixAafficherTotalValue} />

      <Modal isOpen={initializeModal} toggle={handleToggleInitialize}>
        <ModalHeader toggle={handleToggleInitialize}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Réinitialiser la page</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous vraiment vider tous les champs de la page ?
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-danger linesConfirmationBtn linesDeleteBtn"
                  onClick={initializeHandle}
                  ><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp;Réinitialiser</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: IVenteReduxProps) => ({
  encaissementline: state.encaissementline,
  bien: state.bien,
  user: state.user,
  auth: state.auth
});

export default connect(mapStateToProps, { clearEncaissementLines, getUsers, clearTableClients, getRemainingEncaissements })(VenteContainerComponent);
